import { api } from '../../services/api'
import { showError, showSuccess } from '../misc/misc.actions'

export const getApartmentList = (market_id) => {
	return (dispatch) => {
		dispatch({ type: 'GET_APARTMENT_LIST' })

		return api
			.get(`/apartments/${market_id}`)
			.then((response) => {
				dispatch({ type: 'GET_APARTMENTS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_APARTMENTS_FAIL' })
			})
	}
}

export const getFacilities = () => {
	return (dispatch) => {
		dispatch({ type: 'GET_FACILITIES' })

		return api
			.get('/facilities')
			.then((response) => {
				dispatch({ type: 'GET_FACILITIES_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_FACILITIES_FAIL' })
			})
	}
}

export const reloadFacilities = (showLoading) => {
	return (dispatch) => {
		if (showLoading !== false) dispatch({ type: 'GET_FACILITIES' })

		return api
			.get('/facilities')
			.then((response) => {
				dispatch({ type: 'RELOAD_FACILITIES_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_FACILITIES_FAIL' })
			})
	}
}

export const updateFacility = (facilityId, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.patch(`/facilities/${facilityId}`, updates)
			.then((response) => {
				dispatch(showSuccess(`Facility updated!`))
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data
						: 'An error occured while updating the selected Facility.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error || 'An error occured while updating the selected Facility.'
				})
			})
	}
}

export const getFacilityAdvancedSettings = (facilityId) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.get(`/facilities/${facilityId}/advancedSettings`)
			.then((response) => {
				const payload = response?.data || {}
				const data = payload.data || {}
				// Clear loading only — do not merge into selected (would race App facility restore).
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: {} })

				return {
					...data,
					migrated: payload.migrated
				}
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data.error || e.response.data
						: 'An error occured while loading facility memberships.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error
				})

				return null
			})
	}
}

export const updateFacilityAdvancedSettings = (facilityId, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.patch(`/facilities/${facilityId}/advancedSettings`, updates)
			.then((response) => {
				dispatch(showSuccess(`Facility memberships updated!`))
				const facility = response?.data?.data || response?.data || {}
				dispatch({
					type: 'UPDATE_FACILITY_SUCCESS',
					payload: {
						launch: facility.launch,
						updatedAt: facility.updatedAt
					}
				})

				return facility
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data.error || e.response.data
						: 'An error occured while updating facility memberships.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error
				})

				return null
			})
	}
}

export const updateFacilityCapacity = (facilityId, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.put(`/facilities/${facilityId}/capacity`, updates)
			.then((response) => {
				dispatch(showSuccess(`Facility capacity updated!`))
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data
						: 'An error occured while updating the selected Facility capacity.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error || 'An error occured while updating the selected Facility capacity.'
				})
			})
	}
}

export const updateFacilityIndividual = (facilityId, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.patch(`/facilityIndividual/${facilityId}`, updates)
			.then((response) => {
				dispatch(showSuccess(`Facility updated!`))
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data
						: 'An error occured while updating the selected Facility.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error || 'An error occured while updating the selected Facility.'
				})
			})
	}
}

export const updateFacilityIndividualAsync = async (
	dispatch,
	facilityId,
	updates,
	successMessage = 'Facility updated!'
) => {
	dispatch({ type: 'UPDATE_FACILITY' })

	try {
		const response = await api.patch(`/facilityIndividual/${facilityId}`, updates)
		dispatch(showSuccess(successMessage))
		dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
	} catch (e) {
		const error =
			e && e.response && e.response.data
				? e.response.data
				: 'An error occured while updating the selected Facility.'
		dispatch(showError(error))
		dispatch({
			type: 'UPDATE_FACILITY_FAIL',
			payload: error || 'An error occured while updating the selected Facility.'
		})
	}
}

// Deprecated
export const updateFeaturedEvent = (facilityId, featuredEvent) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.patch(`/facilities/${facilityId}/featuredEvent`, { featured_event: featuredEvent })
			.then((response) => {
				dispatch(showSuccess('Featured event updated!'))
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data
						: 'An error occured while updating the featured event.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error || 'An error occured while updating the featured event.'
				})
			})
	}
}

// DEPRECATED
export const updateFriendsOfSkiptown = (facilityId, friendsOfSkiptown) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.patch(`/facilities/${facilityId}/friendsOfSkiptown`, { friends_of_skiptown: friendsOfSkiptown })
			.then((response) => {
				dispatch(showSuccess('Friends of Skiptown updated!'))
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data
						: 'An error occured while updating Friends of Skiptown.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error || 'An error occured while updating Friends of Skiptown.'
				})
			})
	}
}

/**
 * Updating Friends of Skiptown global headings in Facilty Marketing
 */
export const updateFriendsOfSkiptownSection = (facilityId, section) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.patch(`/facilities/${facilityId}/friendsOfSkiptown/section`, section)
			.then((response) => {
				dispatch(showSuccess('Friends of Skiptown updated!'))
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })

				return response.data
			})
			.catch((e) => {
				const error =
					e && e.response && e.response.data
						? e.response.data
						: 'An error occured while updating Friends of Skiptown.'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error || 'An error occured while updating Friends of Skiptown.'
				})
			})
	}
}

export const createOrDelete = (facilityId, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.put(`/facilities/${facilityId}/createOrDelete`, updates)
			.then((response) => {
				dispatch(showSuccess(`Facility updated!`))
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error = e && e.response && e.response.data ? e.response.data : null
				if (error) dispatch(showError(error))
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: error || 'An error occured while updating the selected Facility.'
				})
			})
	}
}

export const setFacility = (facility) => {
	return async (dispatch) => {
		await dispatch({ type: 'SET_SELECTED_FACILITY', payload: facility })
	}
}

export const saveStaff = (groupId, obj) => {
	return async (dispatch) => {
		return api
			.put(`/facilities/${groupId}/staff`, obj)
			.then((response) => {
				// dispatch({ type: "GET_FACILITIES_SUCCESS", payload: response.data });
			})
			.catch(() => {
				// dispatch({ type: "GET_FACILITIES_FAIL" });
			})
	}
}

export const assignKennels = (facilityId, playgroup_id, kennels) => {
	return async (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })
		dispatch({
			type: 'ASSIGN_KENNELS',
			payload: { playgroup_id, facilityId, kennels }
		})

		return api
			.put(`/facilities/${facilityId}/kennels`, { kennels, playgroup_id })
			.then((response) => {
				dispatch({
					type: 'UPDATE_FACILITY_SUCCESS',
					payload: { kennels: response.data.kennels }
				})
			})
			.catch(() => {
				dispatch({ type: 'GET_FACILITIES_FAIL' })
			})
	}
}

export const saveArea = (facility_id, group, area) => {
	return async (dispatch) => {
		dispatch({
			type: 'SAVE_AREA',
			payload: { group, area }
		})

		return api
			.put(`/facilities/${facility_id}/playgroups/${group._id}/areas`, {
				area_id: area._id
			})
			.then((response) => {
				// dispatch({ type: "GET_FACILITIES_SUCCESS", payload: response.data });
			})
			.catch(() => {
				// dispatch({ type: "GET_FACILITIES_FAIL" });
			})
	}
}

export const setAutoCap = (date, facilityId, type, capacity) => {
	return async (dispatch) => {
		dispatch({ type: 'SERVICE_PAGE_LOADING' })

		return api
			.post(`/${facilityId}/${date}/${type}/autoCap`, { capacity })
			.then((response) => {
				console.log(response.data)
				dispatch({
					type: 'ADD_AUTOCAP',
					payload: response.data
				})
			})
			.catch((e) => {
				console.log('error in here...', e)
				dispatch({ type: 'GET_COUNT_FAILED' })
			})
	}
}

export const removeAutoCap = (cap) => {
	return async (dispatch) => {
		dispatch({ type: 'SERVICES_LOADING' })

		return api
			.post(`/removeCap/${cap._id}`)
			.then((response) => {
				// console.log(response.data)
				dispatch({
					type: 'REMOVE_AUTOCAP',
					payload: cap
				})
			})
			.catch(() => {
				dispatch({ type: 'GET_COUNT_FAILED' })
			})
	}
}

export const recalculateCap = (date, facility_id, sundayStart) => {
	return async (dispatch) => {
		dispatch({ type: 'SERVICE_PAGE_LOADING' })

		return api
			.post(`/recalculateCap/${facility_id}?date=${date}`)
			.then((response) => {
				console.log(response.data)
				dispatch(getAggregatedVisits(facility_id, sundayStart))
			})
			.catch(() => {
				dispatch({ type: 'GET_COUNT_FAILED' })
			})
	}
}

export const getAggregatedVisits = (facilityId, date) => {
	return async (dispatch) => {
		dispatch({ type: 'GET_VISIT_COUNTS' })

		return api
			.get(`/${facilityId}/${date}/getAggregatedVisits`)
			.then((response) => {
				console.log('THE DATA......', response.data)
				dispatch({
					type: 'GET_AGGREGATED_VISITS_SUCCESS',
					payload: response.data
				})
			})
			.catch(() => {
				dispatch({ type: 'GET_COUNT_FAILED' })
			})
	}
}
